import type { LeadsUsageEstimation } from '@albacross/frontend-utils'

// A near-empty estimate arrives as 0/50, not 0/0 - the endpoint forces the high end to at least 50.
export const formatEstimatedCompanies = (estimation?: Pick<LeadsUsageEstimation, 'estimatedLow' | 'estimatedHigh'>) =>
  estimation?.estimatedLow && estimation.estimatedHigh
    ? `${estimation.estimatedLow} – ${estimation.estimatedHigh}`
    : '—'
